import * as React from 'react';
import styled from 'styled-components';

import { rem } from '../../tokens/spacing';
import { palette } from '../../tokens/palette';

export interface GoBackProps {
  onClick: () => void;
  label?: string;
}

const Root = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: ${rem(12)};
  cursor: pointer;

  .goBack {
    transition: all 0.2s linear;
    font-size: ${rem(14)};
    color: var(--ui-text-primary, ${palette.Gray});
  }

  .material-symbols-outlined {
    transition: all 0.2s linear;
    font-size: 20px;
    padding-right: 5px;
    color: var(--ui-text-primary, ${palette.Gray});
  }

  &:hover {
    .material-symbols-outlined {
      transform: translateX(-2px);
      color: var(--ui-brand, ${palette.Purple});
    }
    .goBack {
      text-decoration: underline;
      color: var(--ui-brand, ${palette.Purple});
    }
  }
`;

export const GoBack = React.forwardRef<HTMLDivElement, GoBackProps>(
  function GoBack({ onClick, label = 'Go back' }, ref) {
    return (
      <Root
        ref={ref}
        role='button'
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}
      >
        <span className='material-symbols-outlined'>arrow_back</span>
        <span className='goBack'>{label}</span>
      </Root>
    );
  },
);

GoBack.displayName = 'GoBack';
